// extracted by mini-css-extract-plugin
export default {"item":"OptionList--item--IA+++"};